import styled from '@emotion/styled';
import { Variables } from '../../base/variables';

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: 768px) {
        gap: 12px;
    }

    @media (max-width: 480px) {
        gap: 10px;
    }
`;

export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    align-items: start;

    @media (max-width: 1400px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    @media (max-width: 480px) {
        gap: 10px;
    }
`;

export const FormField = styled.div<{ span?: number }>`
    display: flex;
    flex-direction: column;
    grid-column: span ${props => props.span || 1};

    @media (max-width: 1400px) {
        grid-column: span ${props => {
            const span = props.span || 1;
            return span > 3 ? 3 : span;
        }};
    }

    @media (max-width: 1024px) {
        grid-column: span ${props => {
            const span = props.span || 1;
            return span > 2 ? 2 : span;
        }};
    }

    @media (max-width: 768px) {
        grid-column: span 1;
    }
`;

export const Label = styled.label<{ required?: boolean }>`
    font-size: 14px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
    margin-bottom: 8px;

    ${props =>
        props.required &&
        `
        &::after {
            content: ' *';
            color: ${Variables.Colors.warning};
        }
    `}
`;

export const Input = styled.input<{ hasError?: boolean }>`
    width: 100%;
    padding: 8px 12px;
    border: 1px solid ${props => (props.hasError ? Variables.Colors.warning : Variables.Colors.nx8)};
    border-radius: 4px;
    font-size: 14px;
    color: ${Variables.Colors.n100};
    background-color: ${Variables.Colors.white};
    transition: border-color 0.2s;

    &:focus {
        outline: none;
        border-color: ${props => (props.hasError ? Variables.Colors.warning : Variables.Colors.b300)};
    }

    &:disabled {
        background-color: ${Variables.Colors.n15};
        color: ${Variables.Colors.n50};
        cursor: not-allowed;
    }

    &::placeholder {
        color: ${Variables.Colors.n30};
    }
`;

export const Select = styled.select<{ hasError?: boolean }>`
    width: 100%;
    padding: 8px 12px;
    border: 1px solid ${props => (props.hasError ? Variables.Colors.warning : Variables.Colors.nx8)};
    border-radius: 4px;
    font-size: 14px;
    color: ${Variables.Colors.n100};
    background-color: ${Variables.Colors.white};
    cursor: pointer;
    transition: border-color 0.2s;

    &:focus {
        outline: none;
        border-color: ${props => (props.hasError ? Variables.Colors.warning : Variables.Colors.b300)};
    }

    &:disabled {
        background-color: ${Variables.Colors.n15};
        color: ${Variables.Colors.n50};
        cursor: not-allowed;
    }
`;

export const ErrorMessage = styled.span`
    font-size: 12px;
    color: ${Variables.Colors.warning};
    margin-top: 4px;
`;

export const AutocompleteContainer = styled.div`
    position: relative;
`;

export const AutocompleteDropdown = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 200px;
    overflow-y: auto;
    background-color: ${Variables.Colors.white};
    border: 1px solid ${Variables.Colors.nx8};
    border-top: none;
    border-radius: 0 0 4px 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 10;
`;

export const AutocompleteOption = styled.div`
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    color: ${Variables.Colors.n100};

    &:hover {
        background-color: ${Variables.Colors.n15_24};
    }
`;

export const LoadingText = styled.div`
    padding: 8px 12px;
    font-size: 14px;
    color: ${Variables.Colors.n50};
    font-style: italic;
`;

export const NoResults = styled.div`
    padding: 8px 12px;
    font-size: 14px;
    color: ${Variables.Colors.n50};
    font-style: italic;
`;


